import PocketBase from "pocketbase";
export default async function getActivitiesService(
    pb: PocketBase,
    userWalletAddress: string,
    userId: string,
    onSuccess?: (data?: any) => any
) {
    try {
        await checkExpired(pb);
        const records = await pb.collection("transactions").getFullList({
            filter: `user_id="${userId ? userId : "noUserId"}" || user_id="all"`,
            sort: "-created",
        });
        console.log("🚀 ~ getActivitiesService ~ records:", records, userId, pb);
        onSuccess && onSuccess(records);
        return records;
    } catch (err) {
        console.error("🚀 ~ getActivitiesService ~ err:", err);
        throw err;
    }
}
export async function initializePocketbase(pb: any, reset = false) {
    if (!pb || reset) {
        pb = new PocketBase(process.env.NEXT_PUBLIC_PB_URL);
        await pb
            .collection("users")
            .authWithPassword(process.env.NEXT_PUBLIC_PB_EMAIL || "", process.env.NEXT_PUBLIC_PB_PASSWORD || "");

        await pb.autoCancellation(false);
    }
}
export async function checkExpired(pb: any) {
    try {
        console.log("checkExpired", pb.authStore.isValid);

        !pb.authStore.isValid && (await initializePocketbase(pb, true));
    } catch (e) {
        pb.authStore.clear(); // after this call pb.authStore.isValid will be false
    }
}
